import { storeInstance } from './../../store.js';
import * as types from '../NGUD/types';
import Message from '@/components/shared/mixins/Message.js';

const actions = {

  [types.ACTION_GET_INFORMES_DIAGNOSTICO]: ({ commit, getters }, payload) => {
    let request = { controller: `/InformesDiagnostico/Ciudad/${payload.idCiudad}` };

    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/getSuit', request)
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  },
  [types.ACTION_SAVE_DOCUMENTOPDF]: ({ commit, getters }, payload) => {
    let request = {
      controller: '/DocumentoPDF',
      filter: {},
      contentType: 'multipart/form-data',
      body: payload.file
    };
    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/postFile', request)
        .then(response => {
          resolve(response.data.id);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  },
  [types.ACTION_SAVE_INFORME_DIAGNOSTICO]: ({ commit, getters }, payload) => {
    let request = {
      controller: '/InformesDiagnostico/Informe/' + payload.idInforme + '/Ciudad/' + payload.idCiudad,
      filter: {},
      body: payload.datosInforme
    };
    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/postSuit', request)
        .then(response => {
          Message.showMessage('El informe de ha guardado con éxito.');
          resolve(response);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  },
  [types.ACTION_DELETE_INFORME_DIAGNOSTICO]: ({ commit, getters }, payload) => {
    let request = {
      controller: '/InformesDiagnostico/Informe/' + payload.idInforme + '/Ciudad/' + payload.idCiudad,
      filter: {}
    };
    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/deletes', request)
        .then(response => {
          Message.showMessage('El informe se ha eliminado con éxito.');
          resolve(response);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  }
};

export default {
  actions
};
